import autoAssignImg from './Images/autoAssign.svg'
import autoRespImg from './Images/autoResp.svg'
import automationImg from './Images/automations.svg'
import { 
    sla_default_feature_key, 
    sla_custom_feature_key, 
    AI_SUMMARIZER_FEAT_KEY, 
    INTEGRATION_SIDEBAR_CONFIG, 
    csat_feature_key, 
    okta_integration_feature_key, 
    zapier_feature_key, 
    harvey_feature_key, 
    harvey_template_suggestions, 
    chat_contact_from_feature_key,
    chat_nudges_feature_key,
    new_automation_feature_key,
    auto_response_feature_key,
    auto_assignment_feature_key,
    custom_role_feature_key
} from '../../../common';

const slaImg = 'https://cdn.hiverhq.com/extension_images/SLA.svg';

//Addon Feature Names
export const addons = {
    autoAssignment: 'Auto Assignment',
    automations: 'Automations',
    autoResponder: 'Auto Responder',
    sla: 'SLA',
    Integrations: 'Integrations',
    CSAT: 'CSAT',
    'Business Hour': 'Business Hour Templates',
    'Nudges': 'Nudges',
    'okta': 'Okta Provisioning'
}
//Learn More Links from Landing Page
export const learnMore = {
    autoAssignment: 'https://hiverhq.com/features/auto-assign',
    automations: 'https://hiverhq.com/features/automation',
    autoResponder: 'https://help.hiverhq.com/productivity/set-up-an-auto-responder',
    sla: 'https://hiverhq.com/features/sla-management'
}

//Landing Page Titles
export const addonTitle = {
    autoAssignment: 'Automatically assign inbound conversations to your team',
    automations: "Create powerful automations to boost your team’s productivity",
    autoResponder: 'Send an automated response to every new incoming email ',
    sla: 'Achieve timely resolutions by keeping your team accountable'
}

//Landing Page Descriptions
export const addonDescription = {
    autoAssignment: 'Improve accountability in the mailbox by not letting any inbound conversation go unassigned',
    automations: 'Automate repetitive and day-to-day tasks to save valuable time for your team',
    autoResponder: "Set customer expectations by responding with an automated message that fits your resolution workflow",
    sla: 'Add Service Level Agreement (SLA) rules to keep a tab on responding to customers on time'
}

//Landing Page Images
export const addonImage = {
    autoAssignment: autoAssignImg,
    autoResponder: autoRespImg,
    automations: automationImg,
    sla: slaImg,
}

export const addonKey = {
    autoAssignment: 'auto-assignment',
    automations: 'ftr-new-automations-v1',
    autoResponder: 'auto-response',
    sla: 'sla'
}

export const addonLabels = {
    'Auto Assignment': 'auto-assignment',
    'Automations': 'ftr-new-automations-v1',
    'Auto Responder': 'auto-response',
    'SLA': 'sla'
}
export const SLA = 'sla'
export const AUTO_RESPONSE ='autoResponder'
export const AUTO_RESPONSE_KEY ='auto-response'
export const ZAPIER = 'zapier'

export const feature_activated_event = 'ft_activated'
export const contact_us_event = 'ft_cont_feat'

export const getFeatureKey = (featureName) => {
    const featureList = {
        ...addonLabels,
        "ai_summarizer": AI_SUMMARIZER_FEAT_KEY,
        'automations': new_automation_feature_key,
        'autoAssignment': auto_assignment_feature_key,
        'autoResponder': auto_response_feature_key,
        'Business Hour': sla_default_feature_key,
        'chat contact form': chat_contact_from_feature_key,
        'CSAT': csat_feature_key,
        'Custom sla': sla_custom_feature_key,
        'harvey': harvey_feature_key,
        "harvey-template-suggestions": harvey_template_suggestions,
        'Integrations': INTEGRATION_SIDEBAR_CONFIG.features,
        'Nudges': sla_default_feature_key,  // for business hour Nudges
        'okta': okta_integration_feature_key,
        'sla': sla_default_feature_key,
        'zapier': zapier_feature_key,
        'custom role': custom_role_feature_key
    };

    return featureList[featureName] || '';
};